<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg">
        <img src="assets/svg/icon-orange.svg" alt="Crear usuario" />
      </div>
      <div>
        <h4 class="text-semibold">Crear usuario</h4>
        <h6 class="color-gray">
          Completa los datos para registrar un nuevo usuario.
        </h6>
      </div>
      <div>
        <img
          (click)="closeMdl()"
          class="close-button"
          src="assets/svg/close-icon.svg"
          alt=""
        />
      </div>
    </div>

    <div class="mdl-body">
      <h5 class="text-semibold mt-4">Información del usuario</h5>
      <form #UserForm="ngForm">
      <div
        class="d-grid prospect-form"
        style="grid-template-columns: 1fr 1fr; column-gap: 32px"
      >
        <div>
          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!rutFormateado">*</span>
              RUT:
            </label>
            <input
              class="crm-input"
              type="text"
              name="rut"
              [(ngModel)]="rutFormateado"
              (input)="formatearRut($event)"
              (keydown)="manejarTecladoRut($event)"
              placeholder="12.345.678-9"
              maxlength="12"
              required
              #rutCtrl="ngModel"
            />
            <div class="error-text" *ngIf="rutCtrl.invalid && rutCtrl.touched">
              <small *ngIf="rutCtrl.errors?.['required']">
                El RUT es obligatorio
              </small>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!userRequest.nombre || userRequest.nombre.trim()==='' ">*</span>
              Nombres:
            </label>
            <input
              class="crm-input"
              type="text"
              name="nombre"
              [(ngModel)]="userRequest.nombre"
              placeholder="María José"
              (input)="actualizarCamposVirtuales()"
              required
              #nombreCtrl="ngModel"
            />
            <div class="error-text" *ngIf="nombreCtrl.invalid && nombreCtrl.touched">
              <small *ngIf="nombreCtrl.errors?.['required']">
                El nombre es obligatorio
              </small>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label"
              >
              Contraseña:</label
            >
            <div class="password-container">
              <input
                name="contrasena"
                class="crm-input password-input"
                [type]="mostrarContrasena ? 'text' : 'password'"
                [(ngModel)]="userRequest.contrasena"
                placeholder="Se generará automáticamente"
                readonly
              />
              <span class="password-toggle" (click)="toggleMostrarContrasena()">
                <img
                  src="assets/svg/arrow-down-black.svg"
                  alt="Mostrar contraseña"
                  class="eye-icon"
                />
              </span>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">Apodo:</label>
            <input
              class="crm-input"
              name="apodo"
              type="text"
              [value]="apodo"
              placeholder="Se generará automáticamente"
              readonly
            />
          </div>

          <div class="mt-3">
            <label class="login-label">Alias:</label>
            <input
              class="crm-input"
              name="alias"
              type="text"
              [value]="alias"
              placeholder="Se generará automáticamente"
              readonly
            />
          </div>
        </div>

        <div>
          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!userRequest.apellido || userRequest.apellido.trim()===''">*</span>
              Apellidos:
            </label>
            <input
              class="crm-input"
              type="text"
              name="apellido"
              [(ngModel)]="userRequest.apellido"
              placeholder="Ramírez Pérez"
              (input)="actualizarCamposVirtuales()"
              required
              #apellidoCtrl="ngModel"
            />
            <div class="error-text" *ngIf="apellidoCtrl.invalid && apellidoCtrl.touched">
              <small *ngIf="apellidoCtrl.errors?.['required']">
                Los apellidos son obligatorios
              </small>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!userRequest.email || userRequest.email.trim()===''">*</span>
              Correo electrónico:
            </label>
            <input
              class="crm-input"
              type="email"
              name="email"
              [(ngModel)]="userRequest.email"
              placeholder="example@gmail.com"
              (input)="actualizarNombreUsuario()"
              required
              #emailCtrl="ngModel"
            />
            <div class="error-text" *ngIf="emailCtrl.invalid && emailCtrl.touched">
              <small *ngIf="emailCtrl.errors?.['required']">
                El correo es obligatorio
              </small>
              <small *ngIf="emailCtrl.errors?.['email']">
                Debe ingresar un correo válido
              </small>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label"
              >
              Confirmar contraseña:</label
            >
            <div class="password-container">
              <input
                name="confirmarContrasena"
                class="crm-input password-input"
                [type]="mostrarConfirmarContrasena ? 'text' : 'password'"
                [(ngModel)]="confirmarContrasena"
                placeholder="Se generará automáticamente"
                readonly
              />
              <span
                class="password-toggle"
                (click)="toggleMostrarConfirmarContrasena()"
              >
                <img
                  src="assets/svg/arrow-down-black.svg"
                  alt="Mostrar contraseña"
                  class="eye-icon"
                />
              </span>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">Nombre de usuario:</label>
            <input
              class="crm-input"
              type="text"
              [value]="nombreUsuario"
              placeholder="Se generará automáticamente"
              readonly
            />
          </div>

         
        </div>
      </div>

      <div
        class="d-grid prospect-form mt-3"
        style="grid-template-columns: 1fr 1fr; column-gap: 32px"
      >
        <div class="mt-3">
          <label class="login-label"
            >
            <span class="required-asterisk" *ngIf="!userRequest.rolId || userRequest.rolId.trim()===''"></span>
            Perfil de usuario:</label
          >
          <select class="crm-input" [(ngModel)]="userRequest.rolId" required name="rolId" #rolCtrl="ngModel">
            <option value="">-- Selecciona el tipo de perfil --</option>
            <option *ngFor="let rol of rolesDisponibles" [value]="rol.id">
              {{rol.name}}
            </option>
          </select>
          <div class="error-text" *ngIf="rolCtrl.invalid && rolCtrl.touched">
            <small *ngIf="rolCtrl.errors?.['required']">
              El perfil de usuario es obligatorio
            </small>
          </div>
        </div>
        <div class="mt-3">
          <label class="login-label"></label>
        </div>

        <div class="mt-3">
          <label class="login-label">
            <p class="color-org d-inline">*</p>
            Estado inicial:
          </label>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                name="estado"
                [(ngModel)]="userRequest.activo"
                [value]="1"
                required
              />
              Activo
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="estado"
                [(ngModel)]="userRequest.activo"
                [value]="0"
              />
              Inactivo
            </label>
          </div>
        </div>
      </div>
      <div class="mt-5">
        <div class="d-flex justify-content-center gap-3">
          <button (click)="closeMdl()" class="btn btn-primary-outline">
            Cancelar
          </button>
          <button class="btn btn-primary text-center" (click)="createUser()" [disabled]="!UserForm.valid">
            Añadir nuevo usuario
          </button>
        </div>
      </div>
      </form>
    </div>
  </div>
</div>
